import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function HousekeepingRevolution() {
  return <section className="w-full bg-white overflow-hidden" data-id="element-169">
      <div className="relative" data-id="element-170">
        {/* Main layout: two columns */}
        <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[700px] md:min-h-[800px]" data-id="element-171">
          {/* Left Column - White/Cream background with text */}
          <div className="relative z-10 flex flex-col" data-id="element-172">
            {/* Top spacer for title area */}
            <div className="h-32 md:h-48" data-id="element-173" />

            {/* Cream content panel */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="bg-[#f5f0e8] flex-1 px-8 md:px-16 py-12 md:py-16 flex flex-col justify-center" data-id="element-174">
              <h3 className="text-2xl md:text-3xl font-bold text-[#1a2744] mb-4 leading-tight" data-id="element-175">
                Book us anytime,
                <br data-id="element-176" />
                from anywhere
              </h3>
              <p className="text-gray-600 text-sm md:text-base mb-12 max-w-sm leading-relaxed" data-id="element-177">
                Book online 24/7 or call us. Instantly schedule a confirmed
                appointment using our real-time availabilities as seen on our
                online SMART booking pages. Then we show up.
              </p>

              <h3 className="text-2xl md:text-3xl font-bold text-[#1a2744] mb-4 leading-tight" data-id="element-178">
                Personalised
                <br data-id="element-179" />
                pricing online
              </h3>
              <p className="text-gray-600 text-sm md:text-base max-w-sm leading-relaxed" data-id="element-180">
                Book online or call us and instantly obtain personalised pricing
                specific to your unique cleaning needs. No more waiting for
                someone to call you back with a quote.
              </p>
            </motion.div>
          </div>

          {/* Right Column - Image (flipped) */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/1ysEQkSYQsjQLUL79tMi5e/yellow-armchair-living-room-with-copy-space.jpg" alt="Bright living room with yellow armchair demonstrating clean home environment" className="w-full h-full object-cover min-h-[400px]" loading="lazy" style={{
            transform: 'scaleX(-1)'
          }} data-id="element-182" />
          </motion.div>
        </div>

        {/* Overlapping Title - positioned absolutely over the grid */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="absolute top-8 md:top-12 left-0 right-0 z-20 px-6 md:px-12 lg:px-0" data-id="element-183">
          <div className="max-w-7xl mx-auto" data-id="element-184">
            <h2 className="sr-only" data-id="element-185">The Housekeeping Revolution is Here</h2>
            {/* Line 1: The HOUSEKEEPING */}
            <div className="flex items-baseline justify-center gap-3 md:gap-5" aria-hidden="true" data-id="element-186">
              <span className="font-serif-playfair italic text-3xl md:text-5xl lg:text-6xl text-[#1a2744] font-normal" data-id="element-187">
                The
              </span>
              <span className="font-bebas text-5xl md:text-8xl lg:text-[7rem] text-[#1a2744] tracking-wider leading-none" data-id="element-188">
                HOUSEKEEPING
              </span>
            </div>
            {/* Line 2: REVOLUTION is here */}
            <div className="flex items-baseline justify-center gap-3 md:gap-5 -mt-1 md:-mt-3" aria-hidden="true" data-id="element-189">
              <span className="font-bebas text-5xl md:text-8xl lg:text-[7rem] text-[#1a2744] tracking-wider leading-none" data-id="element-190">
                REVOLUTION
              </span>
              <span className="font-serif-playfair italic text-3xl md:text-5xl lg:text-6xl text-[#1a2744] font-normal" data-id="element-191">
                is here
              </span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Second Row: Kitchen image + Text */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20" data-id="element-192">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-193">
          {/* Left - Kitchen Image */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-[400px] md:h-[500px]" data-id="element-194">
            <img src="https://cdn.magicpatterns.com/uploads/d5PKnvhWgmsUjq9vSCHpbU/2.jpg" alt="Spotless white kitchen after professional deep cleaning" className="w-full h-full object-cover" loading="lazy" data-id="element-195" />
          </motion.div>

          {/* Right - Text */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex flex-col justify-center pl-0 md:pl-12" data-id="element-196">
            <h3 className="text-2xl md:text-3xl font-bold text-[#1a2744] mb-4 leading-tight" data-id="element-197">
              Safe, Insured,
              <br data-id="element-198" />
              and Vetted
            </h3>
            <p className="text-gray-600 text-sm md:text-base mb-12 max-w-sm leading-relaxed" data-id="element-199">
              Your peace of mind is our priority. Every cleaner undergoes
              rigorous background checks and is fully insured to protect your
              home and belongings.
            </p>

            <h3 className="text-2xl md:text-3xl font-bold text-[#1a2744] mb-4 leading-tight" data-id="element-200">
              Secure, cash-free
              <br data-id="element-201" />
              payment
            </h3>
            <p className="text-gray-600 text-sm md:text-base max-w-sm leading-relaxed" data-id="element-202">
              Pay securely online with your credit card. No need to worry about
              having cash on hand when your cleaner arrives.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}